<template>
  <div class="row">
    <div class="col-12">
      <div class="form-group mb-25">
        <label class="d-block fs-14 text-black mb-2">{{ $t("adjustment_page.notes") }}</label>
        <textarea
          cols="30"
          rows="5"
          :placeholder="$t('adjustment_page.add_note')"
          class="d-block w-100 bg-white border-0 rounded-1 resize-none fs-14 text-title p-3"
          :value="modelValue"
          @input="$emit('update:modelValue', ($event.target as HTMLTextAreaElement).value)"
        ></textarea>
      </div>
    </div>
    <div class="col-xl-4">
      <button
        class="btn style-one d-inline-block transition border-0 fw-medium text-white rounded-1 fs-md-15 fs-lg-16 mb-60"
        type="button"
        @click="$emit('submit')"
        :disabled="isSubmitting"
      >
        {{ isSubmitting ? $t("adjustment_page.submitting") : $t("adjustment_page.submit_products") }}
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "NotesContent",
  props: {
    modelValue: {
      type: String,
      default: ""
    },
    isSubmitting: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'submit']
});
</script>
